import {
  commonProcessing,
  setImageTrimCanvas,
  setBgImage,
} from "../createjsWrapper/src/main";
import * as constants from "../createjsWrapper/src/utils/constants";
import * as barrage from "./utils/barrage";
import * as createjs from "createjs-module";

class Trim {
  bitmap; // createjs.Bitmap
  trimImageStage; // createjs.Stage

  /**
   * 画面表示のセットアップ
   */
  setupView() {
    // 表示コンテナ作成
    this.trimImageStage = new createjs.Stage("trimImageCanvas");

    // 共通処理（touchデバイス対応、描画更新など)
    commonProcessing(this.trimImageStage);

    // 選択画面で選択された画像をcanvasに配置する
    const imageSrc = $("#trimImageCanvas").data("src");
    this.bitmap = setImageTrimCanvas(this.trimImageStage, imageSrc);

    // 背景画像を表示する
    //const bgImage = document.querySelector(".canvas-bg");
    //setBgImage(this.trimImageStage, bgImage);
  }

  /**
   * 連打防止
   */
  barragePreventAll() {
    barrage.prevent();
  }

  /**
   * trimming-areaのbottom座標を取得
   */
  getTrimmingAreaBottomPoints() {
    const point = this.bitmap.globalToLocal(0, constants.trimPageMargin);
    const pointX: number = point.x;
    const pointY: number = point.y;
    return { x: pointX, y: pointY };
  }

  /**
   * trimmingのscaleを取得
   */
  getTrimmingScale() {
    const scalingSlider = document.getElementById(
      "zoom-slider"
    ) as HTMLInputElement;
    return Number(scalingSlider.value);
  }
}

export default Trim;
